import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=0532edf1&scoped=true&"
import script from "./attachmentList.vue?vue&type=script&lang=js&"
export * from "./attachmentList.vue?vue&type=script&lang=js&"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=0532edf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0532edf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0532edf1')) {
      api.createRecord('0532edf1', component.options)
    } else {
      api.reload('0532edf1', component.options)
    }
    module.hot.accept("./attachmentList.vue?vue&type=template&id=0532edf1&scoped=true&", function () {
      api.rerender('0532edf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attachmentList.vue"
export default component.exports